/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabOrderResultDtoType = (typeof LabOrderResultDtoType)[keyof typeof LabOrderResultDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabOrderResultDtoType = {
  UNKNOWN: 'UNKNOWN',
  QUANTIFERON_NIL_NOT_STIMULATED: 'QUANTIFERON_NIL_NOT_STIMULATED',
  QUANTIFERON_MITOGEN: 'QUANTIFERON_MITOGEN',
  QUANTIFERON_TB_ANTIGEN_1: 'QUANTIFERON_TB_ANTIGEN_1',
  QUANTIFERON_TB_ANTIGEN_2: 'QUANTIFERON_TB_ANTIGEN_2',
  QUANTIFERON_FINDING: 'QUANTIFERON_FINDING',
  TSPOT_ESAT6: 'TSPOT_ESAT6',
  TSPOT_CFP10: 'TSPOT_CFP10',
  TUBERCULIN_INDURATION: 'TUBERCULIN_INDURATION',
  TUBERCULIN_READ_TIME: 'TUBERCULIN_READ_TIME',
  SPUTUM_MATERIAL_SPUTUM: 'SPUTUM_MATERIAL_SPUTUM',
  SPUTUM_MATERIAL_AIRWAYS: 'SPUTUM_MATERIAL_AIRWAYS',
  SPUTUM_MATERIAL_CUSTOM: 'SPUTUM_MATERIAL_CUSTOM',
  SPUTUM_METHOD_SPUTUM_MICROSCOPICAL: 'SPUTUM_METHOD_SPUTUM_MICROSCOPICAL',
  SPUTUM_METHOD_SPUTUM_MOLECULAR: 'SPUTUM_METHOD_SPUTUM_MOLECULAR',
  SPUTUM_METHOD_SPUTUM_CULTURE: 'SPUTUM_METHOD_SPUTUM_CULTURE',
  SPUTUM_METHOD_AIRWAYS_MICROSCOPICAL: 'SPUTUM_METHOD_AIRWAYS_MICROSCOPICAL',
  SPUTUM_METHOD_AIRWAYS_MOLECULAR: 'SPUTUM_METHOD_AIRWAYS_MOLECULAR',
  SPUTUM_METHOD_AIRWAYS_CULTURE: 'SPUTUM_METHOD_AIRWAYS_CULTURE',
  SPUTUM_METHOD_CUSTOM_MICROSCOPICAL: 'SPUTUM_METHOD_CUSTOM_MICROSCOPICAL',
  SPUTUM_METHOD_CUSTOM_MOLECULAR: 'SPUTUM_METHOD_CUSTOM_MOLECULAR',
  SPUTUM_METHOD_CUSTOM_CULTURE: 'SPUTUM_METHOD_CUSTOM_CULTURE',
  XRAY_RX_NUMBER: 'XRAY_RX_NUMBER',
  XRAY_FOLLOWUP: 'XRAY_FOLLOWUP',
  XRAY_FINDING: 'XRAY_FINDING',
  XRAY_FINDING_DOCTOR: 'XRAY_FINDING_DOCTOR',
  XRAY_FINDING_COMMENT: 'XRAY_FINDING_COMMENT',
  XRAY_FILE_LINK: 'XRAY_FILE_LINK',
  QUANTIFERON_TB_WERT_2: 'QUANTIFERON_TB_WERT_2',
  QUANTIFERON_TB_WERT_1: 'QUANTIFERON_TB_WERT_1'
} as const;
